/**
 * Shared LPN filter/select option constants.
 *
 * Keys match API-stored values; labelKey drives i18n translation.
 * Single source of truth used by tio-admin and tio-employee so both
 * apps always agree on which strings are persisted to the backend.
 */

export type LpnOption = { key: string; labelKey: string };

export const FORMAT_OPTIONS: LpnOption[] = [
  { key: 'Online', labelKey: 'lpn.format_options.online' },
  { key: 'In-Person', labelKey: 'lpn.format_options.in_person' },
  { key: 'Hybrid', labelKey: 'lpn.format_options.hybrid' },
  { key: 'Self-Paced', labelKey: 'lpn.format_options.self_paced' },
  { key: 'Spanish', labelKey: 'lpn.format_options.spanish' },
];

export const PROGRAM_OPTIONS: LpnOption[] = [
  { key: 'Associate', labelKey: 'lpn.program_options.associate' },
  { key: "Bachelor's", labelKey: 'lpn.program_options.bachelors' },
  { key: 'Boot Camp', labelKey: 'lpn.program_options.boot_camp' },
  { key: 'Certificate', labelKey: 'lpn.program_options.certificate' },
  { key: 'Doctoral', labelKey: 'lpn.program_options.doctoral' },
  { key: 'GED or HS Diploma', labelKey: 'lpn.program_options.ged_or_hs' },
  { key: "Master's", labelKey: 'lpn.program_options.masters' },
  { key: 'Short Form Course', labelKey: 'lpn.program_options.short_form_course' },
];

export const STUDY_AREA_OPTIONS: LpnOption[] = [
  { key: 'Accounting', labelKey: 'lpn.study_area_options.accounting' },
  { key: 'AI & Machine', labelKey: 'lpn.study_area_options.ai_machine' },
  { key: 'Applied Sciences', labelKey: 'lpn.study_area_options.applied_sciences' },
  { key: 'Business', labelKey: 'lpn.study_area_options.business' },
  { key: 'CFP®', labelKey: 'lpn.study_area_options.cfp' },
  { key: 'Computer Science', labelKey: 'lpn.study_area_options.computer_science' },
  { key: 'Construction Mgmt', labelKey: 'lpn.study_area_options.construction_mgmt' },
  { key: 'Cybersecurity', labelKey: 'lpn.study_area_options.cybersecurity' },
  { key: 'Data Science', labelKey: 'lpn.study_area_options.data_science' },
  { key: 'Education', labelKey: 'lpn.study_area_options.education' },
  { key: 'Executive Education', labelKey: 'lpn.study_area_options.executive_education' },
  { key: 'Healthcare', labelKey: 'lpn.study_area_options.healthcare' },
  { key: 'Human Resources', labelKey: 'lpn.study_area_options.human_resources' },
  { key: 'Integrative Health', labelKey: 'lpn.study_area_options.integrative_health' },
  { key: 'Nursing', labelKey: 'lpn.study_area_options.nursing' },
  { key: 'Project Mgmt/Six Sigma', labelKey: 'lpn.study_area_options.project_mgmt_six_sigma' },
  { key: 'Psychology', labelKey: 'lpn.study_area_options.psychology' },
  { key: 'Public Safety', labelKey: 'lpn.study_area_options.public_safety' },
  { key: 'Security & Global Studies', labelKey: 'lpn.study_area_options.security_global_studies' },
  { key: 'Social Sciences', labelKey: 'lpn.study_area_options.social_sciences' },
  { key: 'STEM', labelKey: 'lpn.study_area_options.stem' },
];

export const SAVINGS_OPTIONS: LpnOption[] = [
  { key: 'capped_tuition', labelKey: 'lpn.savings_options.capped_tuition' },
  { key: 'family_eligible', labelKey: 'lpn.savings_options.family_eligible' },
  { key: 'no_fees', labelKey: 'lpn.savings_options.no_fees' },
];
